/**
 * The session, read once and shared by every screen through the query cache. `signedOut` is not
 * an error to draw: it means "send the reader to /login".
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { fetchMe, ME_QUERY_KEY, type SessionUser, signOut } from '../services/authApi.js';
import { ApiError } from '../services/httpClient.js';

export function useSession() {
  const query = useQuery<SessionUser>({ queryKey: ME_QUERY_KEY, queryFn: fetchMe });
  const error = query.error;
  return {
    user: query.data ?? null,
    isLoading: query.isLoading,
    signedOut: error instanceof ApiError && error.signedOut,
    error: error instanceof ApiError && !error.signedOut ? error : null,
  };
}

export function useSignOut() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: signOut,
    onSuccess: () => {
      queryClient.clear();
    },
  });
}
